import React, { useState, useEffect } from "react";
import LogoImage from "./img/LogoImage.jsx";
import iPhoneImage from "./iPhone 12 Pro (Wooden Hands).png";

const App = () => {
  const [categories, setCategories] = useState([]);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [cardsData, setCardsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [os, setOs] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [dateRange, setDateRange] = useState();
  const [day, setDay] = useState();
  const secondary_title = "Choose Any 5 Minute Tutorial";
  const title = "This Week's Menu";
  // const date_range = "Dec 31-2024 to Jan 3-2025";

  const CATEGORIES_API =
    "http://35.202.100.254/oe/api/admin/mb-title-sub-categories-by-tutorial-count";
  const WEEKLY_API =
    "http://35.202.100.254/oe/api/admin/get-list-of-weekly-title";

  const baseImageUrl = "http://35.202.100.254/oe/";

  const colorMap = {
    "Azure Cloud": "#0000ff",
    "Cyber Security": "#ce0ff5",
    "IT Infrastructure": "#FFA500",
    Microsoft: "#ff0000",
    "Professional Development": "#008001",
  };

  function dayPicker() {
    const today = new Date();
    const day = today.getDay();
    console.log(day);
    setDay(day);
  }

  useEffect(() => {
    fetch(CATEGORIES_API)
      .then((res) => res.json())
      .then((jsonData) => {
        if (jsonData.status === 1 && Array.isArray(jsonData.data)) {
          setCategories(jsonData.data);
        } else {
          console.error("Invalid categories data:", jsonData);
        }
      })
      .catch((err) => console.error("Error fetching categories:", err));
  }, []);

  useEffect(() => {
    const getOperatingSystem = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      console.log("User Agent:", userAgent); // Debugging the user agent

      if (/android/i.test(userAgent)) {
        console.log("Android detected");
        setOs(
          "https://play.google.com/store/apps/details?id=com.skillsets&pcampaignid=web_share"
        );
      } else if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
        console.log("iOS detected");
        setOs("https://testflight.apple.com/join/ce1c90WY");
      } else if (/Macintosh/i.test(userAgent)) {
        setOs("https://testflight.apple.com/join/ce1c90WY");
      } else if (/Windows/i.test(userAgent)) {
        setOs(
          "https://play.google.com/store/apps/details?id=com.skillsets&pcampaignid=web_share"
        );
      } else {
        console.log("Unknown OS detected");
        setOs(
          "https://play.google.com/store/apps/details?id=com.skillsets&pcampaignid=web_share"
        );
      }

      // Ensure `isLoaded` is set to true after processing
      setIsLoaded(true);
    };

    getOperatingSystem();
    dayPicker();
  }); // Runs only once after the component mounts

  useEffect(() => {
    fetch(WEEKLY_API)
      .then((res) => res.json())
      .then((jsonData) => {
        if (jsonData.dateRange) {
          setDateRange(jsonData.dateRange);
        }
      });
  });
  const handleCategoryClick = (categoryName) => {
    if (expandedCategory === categoryName) {
      setExpandedCategory(null);
    } else {
      setExpandedCategory(categoryName);
      if (!cardsData[categoryName]) {
        setLoading(true);
        fetch(WEEKLY_API)
          .then((res) => res.json())
          .then((jsonData) => {
            if (Array.isArray(jsonData.getAssignedTitleAvgRating)) {
              const filteredCards = jsonData.getAssignedTitleAvgRating.filter(
                (item) => item.sub_category_name === categoryName
              );
              setCardsData((prev) => ({
                ...prev,
                [categoryName]: filteredCards,
              }));
            } else {
              console.error("Unexpected data structure:", jsonData);
            }
          })
          .catch((err) => console.error("Error fetching weekly data:", err))
          .finally(() => setLoading(false));
      }
    }
  };

  return (
    <div
      className="relative flex flex-col md:flex-row h-screen bg-no-repeat bg-bottom bg-cover"
      style={{
        backgroundImage: `linear-gradient(#F5F7FE, #F5F7FE), url('./wave-art-bg-white-down.svg')`,
      }}
    >
      <div className="absolute top-0 left-0 right-0 flex flex-col items-center mt-4 z-20 md:flex-row md:items-start">
        {/* Logo */}
        <div className="md:absolute md:top-4 md:left-4 flex items-center justify-center sm:mb-4 md:mb-0">
          <LogoImage />
        </div>

        {/* Text */}
        <div className="flex flex-col items-center mt-4 md:mt-0 md:absolute md:top-[60px] md:left-0 md:right-0 md:mr-[600px]">
          <h1 className="text-xl md:text-2xl font-semibold mt-2 text-black">
            {title}
          </h1>
          <h1 className="text-xl  md:text-2xl font-semibold mt-2 text-black">
            {dateRange}
          </h1>
        </div>
        <div className="block top-[220px] left-[20px] md:block absolute md:top-[180px] md:left-40">
          <h1 className="text-md md:text-lg font-bold text-black">
            {secondary_title}
          </h1>
        </div>
      </div>

      {/* Left Side - Categories */}
      <div className="w-full md:w-1/2 pt-16 p-4 md:p-8 z-10">
        {/*
          2) Add bigger gap between bars => space-y-4
        */}
        <div className=" space-y-6 mt-52">
          {categories.map((category) => {
            const bgColor = colorMap[category.sub_category_name] || "#666";
            return (
              <div
                key={category.id}
                className="border rounded-lg shadow-md overflow-hidden md:ml-32"
              >
                <div
                  onClick={() =>
                    handleCategoryClick(category.sub_category_name)
                  }
                  className="flex items-center justify-between p-1 md:p-1.5 cursor-pointer"
                  style={{
                    backgroundColor: bgColor,
                    color: "white",
                    height: "40px",
                  }}
                >
                  <div className="flex items-center">
                    <img
                      src={`${baseImageUrl}${category.category_picture}`}
                      alt={category.sub_category_name}
                      className="w-5 h-5 md:w-6 md:h-6 mr-2 p-1 bg-slate-50"
                    />
                    <span className="text-xs md:text-sm font-semibold">
                      {category.sub_category_name}
                      {/* ({category.tutorial_count || 0}) */}
                    </span>
                  </div>
                  <span className="text-base md:text-lg">
                    {expandedCategory === category.sub_category_name
                      ? "▲"
                      : "▼"}
                  </span>
                </div>

                {expandedCategory === category.sub_category_name && (
                  <div className="bg-white max-h-52 overflow-y-auto p-2 md:p-3 space-y-2 rounded shadow-md">
                    {loading ? (
                      <p className="text-xs md:text-sm text-gray-400">
                        Loading...
                      </p>
                    ) : (
                      (cardsData[category.sub_category_name] || []).map(
                        (card) => (
                          <div
                            key={card.title_id}
                            className="bg-white border rounded-lg p-2 md:p-3 shadow-md text-black font-semibold"
                          >
                            <span className="text-xs md:text-sm font-semibold mb-2">
                              {" "}
                              {card.title_name}
                            </span>
                            <p className="text-xs text-blue-600 mb-2">
                              {card.sub_sub_category_name}
                            </p>
                            <p className="text-xs text-black underline mb-2">
                              Includes:
                            </p>

                            <div className="flex flex-wrap gap-1 mb-3">
                              {Array.from(
                                new Set(card.tag_names.split(","))
                              ).map((tag, index) => (
                                <span
                                  key={index}
                                  className="bg-blue-600 text-white px-2 py-1 rounded-xl text-[10px] md:text-xs"
                                >
                                  {tag}
                                </span>
                              ))}
                            </div>
                            <div className="flex flex-row justify-between">
                              <a
                                href={os}
                                className="text-blue-600 underline text-xs"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open Tutorial →
                              </a>
                              {card.positive_percentage > 85 &&
                              day != 1 &&
                              day != 2 ? (
                                <div className="flex flex-row gap-x-1 items-center">
                                  <div className="flex flex-row">
                                    <p className="text-sm">
                                      Global Rating:{" "}
                                      {Math.trunc(card.positive_percentage)}%
                                    </p>
                                  </div>
                                  <div>⭐</div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        )
                      )
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {/* Right Side - Image */}
      <div className="hidden md:flex w-1/2 items-center justify-center relative z-10">
        <img
          src={iPhoneImage}
          alt="iPhone Display"
          className="absolute bottom-0 right-0 max-h-[90%] max-w-[90%]"
        />
      </div>
    </div>
  );
};

export default App;
